import { Avatar } from "antd"
import React from "react"
import { getLogoUrl } from "~Shared/utils/logo.utils"

const personioLogo = getLogoUrl({ domain: "personio.com", format: "webp" })

export const PersonioTag = ({ ...props }) => <Avatar {...props} size="small" icon={<img src={personioLogo} alt="Imported from Personio" />} className="ml-10" />
